module.exports = __webpack_public_path__ + "static/media/Hound-Unselected.9972af91.png";